<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="漂流链" text="书籍漂流链列表">
          <v-layout row wrap class="mx-3">
            <v-layout row wrap xs12>
              <v-flex sm3>
                <v-text-field hide-details label="书名" v-model="searchBook"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field hide-details label="漂流链名称" v-model="searchLink"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-dialog
                  ref="dialog"
                  v-model="dateDialog"
                  :return-value.sync="searchDate"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <v-date-picker v-model="searchDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dateDialog = false">取消</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(searchDate)">确定</v-btn>
                  </v-date-picker>
                </v-dialog>

                <v-text-field
                  hide-details
                  label="创建时间"
                  v-model="searchDate"
                  @click="dateDialog=true"
                ></v-text-field>
              </v-flex>
              <v-flex sm3 class="text-no-wrap">
                <v-btn color="orange" dark class="mx-2" @click="onClickReset">重置</v-btn>
                <v-btn color="green" dark @click="onClickSearch">查询</v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :pagination.sync="pagination"
                :rows-per-page-items="rowsPerPageItems"
                :disable-initial-sort="true"
              >
                <template slot="headerCell" slot-scope="{ header }">
                  <span
                    class="subheading font-weight text-success text--darken-3"
                    v-text="header.text"
                  />
                </template>
                <template slot="items" slot-scope="{ item }">
                  <td>{{ item.id }}</td>
                  <td>{{ "《" + item.bookName + "》" }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ formateDate(item.createdAt) }}</td>
                  <td class="text-xs-right">{{ item.readerCount }}</td>
                  <td class="text-xs-right">{{ item.rankValue }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
import { getLinkRanksByPage } from '@/services'

export default {
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id'
      },
      {
        text: '书籍',
        value: 'bookName'
      },
      {
        text: '漂流链名',
        value: 'name'
      },
      {
        text: '创建时间',
        value: 'createdAt'
      },
      {
        text: '链内人数',
        value: 'readerCount',
        align: 'right',
        icon: 'mdi-account-multiple'
      },
      {
        text: '排名',
        value: 'rankValue',
        align: 'right'
      }
    ],
    items: [],
    rowsPerPageItems: [2, 5, 10, 20, 50],
    pagination: {
      page: 1,
      rowsPerPage: 5,
      descending: false,
      sortBy: null
    },
    criteria: [],
    searchBook: null,
    searchLink: null,
    searchDate: null,
    dateDialog: false
  }),

  computed: {
    tempParams() {
      return {
        descending: this.pagination.descending || null,
        page: this.pagination.page || null,
        rowsPerPage: this.pagination.rowsPerPage || null,
        sortBy: this.pagination.sortBy || null
      }
    },

    totalItems() {
      return (this.pagination && this.pagination.totalItems) || 0
    }
  },

  watch: {
    tempParams: {
      async handler(oldValue, newValue) {
        // console.log('oldValue', JSON.stringify(oldValue))
        if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
          return
        }
        // console.log('newValue', JSON.stringify(newValue))
        await this.fetchData()
      }
    }
  },

  async beforeMount() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      let pagination = await getLinkRanksByPage({
        ...this.pagination,
        criteria: this.criteria
      })

      if (pagination) {
        // remove items from pagination
        this.pagination = { ...pagination, items: [] }
        this.items = pagination.items
      }
    },

    formateDate(x) {
      return dayjs(x).format('YYYY-MM-DD HH:mm')
    },

    async onClickSearch() {
      let criteria = []
      if (this.searchBook) {
        criteria.push({
          name: 'bookName',
          op: 'like',
          value: `%${this.searchBook.replace(/《|》/g, '')}%`
        })
      }

      if (this.searchLink) {
        criteria.push({
          name: 'name',
          op: 'like',
          value: `%${this.searchLink}%`
        })
      }

      if (this.searchDate) {
        criteria.push({
          name: 'createdAt',
          op: 'between',
          value: dayjs(this.searchDate).format('YYYY-MM-DD'),
          value2: dayjs(this.searchDate).format('YYYY-MM-DD 23:59:59')
        })
      }

      this.criteria = criteria
      await this.fetchData()
    },

    async onClickReset() {
      this.criteria = []
      this.searchBook = null
      this.searchLink = null
      this.searchDate = null
      await this.fetchData()
    }
  }
}
</script>
